import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './utils/auth.guard';
import { PrivacyPolicyComponent } from './pages/rules/privacy-policy.component';
import { StripePaymentStatusComponent } from './pages/stripe-payment-status/stripe-payment-status.component';

const routes: Routes = [
  {
    path: 'tabs',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'signin',
    loadChildren: () => import('./pages/signin/signin.module').then( m => m.SigninPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'edit-profile',
    loadChildren: () => import('./pages/edit-profile/edit-profile.module').then( m => m.EditProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'trainers',
    loadChildren: () => import('./pages/trainers/trainers.module').then( m => m.TrainersPageModule)
  },
  {
    path: 'trainer-profile/:id',
    loadChildren: () => import('./pages/trainer-profile/trainer-profile.module').then( m => m.TrainerProfilePageModule)
  },
  {
    path: 'course-detail/:id',
    loadChildren: () => import('./pages/course-detail/course-detail.module').then( m => m.CourseDetailPageModule)
  },
  {
    path: 'class-detail/:id',
    loadChildren: () => import('./pages/class-detail/class-detail.module').then( m => m.ClassDetailModule)
  },
  {
    path: 'classes-modality/:id',
    loadChildren: () => import('./pages/workout-tips/workout-tips.module').then( m => m.WorkoutTipsPageModule)
  },
  {
    path: 'workouttip-detail/:id',
    loadChildren: () => import('./pages/workouttip-detail/workouttip-detail.module').then( m => m.WorkouttipDetailPageModule)
  },
  {
    path: 'new-account',
    loadChildren: () => import('./pages/new-account/new-account.module').then( m => m.NewAccountPageModule)
  },
  {
    path: 'activity/:id',
    loadChildren: () => import('./pages/activity/activity.module').then( m => m.ActivityPageModule)
  },
  {
    path: 'courses',
    loadChildren: () => import('./pages/courses/courses.module').then( m => m.CoursesPageModule)
  },
  {
    path: 'calendar',
    loadChildren: () => import('./pages/calendar/calendar.module').then( m => m.CalendarPageModule)
  },
  {
    path: 'rules',
    loadChildren: () => import('./pages/rules/rules.module').then( m => m.RulesModule)
  },
  {
    path: 'contract-view/:contractId',
    loadChildren: () => import('./pages/contract-view/contract-view.module').then( m => m.ContractViewPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'stripe/privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'stripe/payment-success',
    component: StripePaymentStatusComponent,
    data: { status: 'success' }
  },
  {
    path: 'stripe/payment-error',
    component: StripePaymentStatusComponent,
    data: { status: 'error' }
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then( m => m.NotificationsPageModule)
  },

  {
    path: 'routine-workouts/:id',
    loadChildren: () => import('./pages/routine-workouts/routine-workouts.module').then( m => m.RoutineWorkoutsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'workout-exercises/:id',
    loadChildren: () => import('./pages/workout-exercises/workout-exercises.module').then( m => m.WorkoutExercisesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'muscle-groups',
    loadChildren: () => import('./pages/muscle-groups/muscle-groups.module').then(m => m.MuscleGroupsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'muscle-group-exercises/:group',
    loadChildren: () => import('./pages/muscle-group-exercises/muscle-group-exercises.module').then(m => m.MuscleGroupExercisesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'tabs/home',
    pathMatch: 'full'
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
